<template>
	<div class="omapi-tabnav">
		<div
			v-for="(value, index) in tabs"
			:key="index"
			class="omapi-tabnav__item"
			:class="{'omapi-tabnav__item-active': isActive(index)}"
			@click="$emit('go', index, $event)"
		>{{ value }}</div>
	</div>
</template>

<script>
export default {
	props : {
		active : {
			type : String,
			default () {
				return ''
			},
		},
		tabs : {
			type : Object,
			default () {
				return {}
			},
		},
	},
	methods : {
		isActive (key) {
			return key === this.active
		},
	},
}
</script>
<style lang="scss">
@import '../../assets/scss/tabnav';
</style>
